<template>
  <input v-if="editando" :value="value" @blur="blur()" @keyup.enter="blur()" ref="input" class="form-control form-control-sm"/>
  <div v-else @dblclick="focus()" style="line-height: 1.85rem; cursor: copy">{{ value }}</div>
</template>
<script>
export default {
  data() {
    return {
      editando: false
    }
  },
  props: ['value'],
  methods: {
    focus() {
      this.editando = true
      setTimeout(function(){
        this.$refs.input.focus()
      }.bind(this), 10)
    },
    blur() {
      if (this.editando) {
        this.editando = false
        this.$emit('input', this.$refs.input.value)
      }
    }
  }
}
</script>
